exports.components = {
  "component---src-pages-beta-success-js": () => import("./../../../src/pages/beta-success.js" /* webpackChunkName: "component---src-pages-beta-success-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

